module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "menu-wrap"
  }, [_vm._l((_vm.menuInfo2), function(item, index) {
    return _c('div', {
      staticClass: "icon-menu",
      on: {
        "click": function($event) {
          _vm.clickMenu(item.permission, item.title)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "img-wrap",
      style: ({
        'background-color': item.bkColor
      })
    }, [_c('div', {
      staticClass: "top"
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "width": "49%"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "footer-margin"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e0752ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountAdmin/AccountAdminHome.vue
// module id = 1444
// module chunks = 7